<template>
  <div class="create-chronology-main">
    <title-screen title ="7" v-show="!hideTitle"></title-screen>
    <div class="text-right text-center-mobile">
      <el-button @click="deleteMemberFamilyDialogVisible = true" :disabled="memberFamilies.length===0">家族を削除する</el-button>
      <el-button @click="createMemberFamily()">家族を追加する</el-button>
    </div>
    <div class="table-responsive table-shadow">
      <table class="table m-0" id="table-chronology">
        <thead>
          <tr>
            <th v-if="countOpen === 0"></th>
            <th style="min-width: 150px"></th>
            <th style="min-width: 130px">対象者</th>
            <th style="min-width: 150px">関係</th>
            <th style="min-width: 230px">生年月日</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(member, mIndex) in memberFamilies">
            <tr :key="member.id" :value="member.id" type="member">
              <td v-if="countOpen === 0" class="allow-drag">
                <label><i class="el-icon-s-operation"></i></label>
              </td>
              <td>
                <el-button class="mx-1" @click="addChronicle(member.id)" size="small">イベント追加</el-button>
                <el-button class="mx-1" @click="editMemberFamily(member.id)" size="small">家族を編集する</el-button>
              </td>
              <td>{{member.name}}</td>
              <td>{{relationshipName(member.relationshipId)}}</td>
              <td>
                <div class="d-flex align-items-center" v-if="!member.isShowDetailChronicle">
                  <div class="w-100p">{{member.birthday | formatDate}}</div>
                  <button class="btn-detail" @click="showDetailChronicle(member)">+</button>
                </div>
                <div class="d-flex align-items-center" v-if="member.isShowDetailChronicle">
                  <div class="w-100p">{{member.birthday | formatDate}}</div>
                  <button class="btn-detail pl-3" @click="closeDetailChronicle(member)">-</button>
                </div>
              </td>
            </tr>
            <template v-if="member.isShowDetailChronicle">
              <tr :key="member.name" class="bg-blue">
                <td></td>
                <td>発生年</td>
                <td>イベント選択</td>
                <td>イベント表示内容</td>
              </tr>
              <tr v-for="(chronicle, index) in member.myChronicleResponseDTOS" :id="`chronicle_${member.id}_${index}`" :key="member.id+'_'+index" v-bind:class="chronicle.id ? '' : 'bg-lightblue'">
                <td><el-button @click="removeChronicle(member.id, index)" size="small">削除</el-button></td>
                <td>
                  <div class="d-flex align-items-center event-year">
                    <el-input type="number" class="w-100 mr-10 text-center-mobile" :value="formatEventYear(chronicle, member.birthday, chronicle.eventYear)" @input="changeEventYear($event, chronicle, member.birthday)"></el-input>年
                  </div>
                </td>
                <td>
                  <life-event-select
                    v-model="chronicle.eventMasterId"
                    :chronicle="chronicle"
                    :changeAction="changeEventMaster"
                    :eventMasters="eventMasters"
                    :member="member"
                  ></life-event-select>
                </td>
                <td><el-input class="w-200 event-name__input" placeholder="自由入力" :disabled="isDisableEventName(chronicle.eventMasterId)" v-model="chronicle.eventName"></el-input></td>
              </tr>
              <tr :key="'header_' + member.id" v-if="mIndex !== memberFamilies.length-1">
                <th></th>
                <th>対象者</th>
                <th>関係</th>
                <th>生年月日</th>
              </tr>
            </template>
          </template>
        </tbody>
      </table>
    </div>
    <div style="text-align: center" class="text-center-mobile">
      <el-button @click="gotoFamilyTimeline" class="mr-auto" :disabled="isLoading">My家族年表を見る</el-button>
      <el-button @click="saveChronicle" :disabled="isLoading || memberFamilies.length===0">イベントを保存する</el-button>
    </div>
    <el-dialog
      class="create-member-family-dialog"
      :visible.sync="actionMemberFamilyDialogVisible"
      :close-on-click-modal="false"
      :before-close="handleCloseActionMemberFamilyFamily"
    >
      <div class="dialog-content dialog-content-mobile">
        <div v-if="isShowActionMemberFamilyFamily">
          <p class="title">
            {{memberFamilyAction === MEMBER_ACTION.CREATE ? '家族を追加します' : '家族を編集します'}}
          </p>
          <div class="mt-20 pl-50 pl-0-m">
            <el-form :model="actionMemberFamily" :rules="actionMemberFamilyRules" ref="actionMemberFamily">
              <el-form-item label="氏名" prop="name" class="p-30 msg-p-70">
                <div class="w-100-m">
                  <el-input type="text" class="mw-250 sm-mw-100p" v-model="actionMemberFamily.name" :disabled="actionMemberFamily.relationshipId === 1" ></el-input>
                </div>
              </el-form-item>
              <el-form-item label="続柄" prop="relationshipId" v-if="memberFamilyAction === MEMBER_ACTION.CREATE" class="p-30 msg-p-70">
                <div class="w-100-m">
                  <relationship-select
                    v-model="actionMemberFamily.relationshipId"
                    :relationships="this.relationships"
                    className="mw-250"
                  ></relationship-select>
                </div>
              </el-form-item>
              <el-form-item label="生年月日" prop="birthday" class="msg-p-70">
                <div class="w-100-m">
                  <date-select v-model="actionMemberFamily.birthday" :disabled="actionMemberFamily.relationshipId === 1" :default-year="'1960'"></date-select>
                </div>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div v-if="!isShowActionMemberFamilyFamily">
          <p class="title">{{memberFamilyAction === MEMBER_ACTION.CREATE ? '以下を追加します。よろしいですか？' : '以下を編集します。よろしいですか？'}}</p>
          <div class="mt-20 pl-50 pl-0-m">
            <div class="mt-20">
              <label class="mr-10 list-inline-item">氏名</label>
              <div class="list-inline-item">{{actionMemberFamily.name}}</div>
            </div>
            <div class="mt-20" v-if="memberFamilyAction === MEMBER_ACTION.CREATE">
              <label class="mr-10 list-inline-item">続柄</label>
              <div class="list-inline-item">{{relationshipName(actionMemberFamily.relationshipId)}}</div>
            </div>
            <div class="mt-20">
              <label class="mr-10 list-inline-item">生年月日</label>
              <div class="list-inline-item">{{actionMemberFamily.birthday | formatDate}}</div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer">
        <div v-if="isShowActionMemberFamilyFamily" class="btn-center-mobile">
          <el-button type="danger" @click="handleCloseActionMemberFamilyFamily">やめる</el-button>
          <el-button v-if="actionMemberFamily.relationshipId !== 1" type="primary" @click="nextToConfirmActionMemberFamilyFamily">{{memberFamilyAction === MEMBER_ACTION.CREATE ? '追加する' : '編集する'}}</el-button>
        </div>
        <div v-if="!isShowActionMemberFamilyFamily" class="btn-center-mobile">
          <el-button type="danger" @click="isShowActionMemberFamilyFamily = true">やめる</el-button>
          <el-button type="primary" @click="saveMemberFamily">{{memberFamilyAction === MEMBER_ACTION.CREATE ? '追加する' : '編集する'}}</el-button>
        </div>
      </span>
    </el-dialog>
    <el-dialog
      class="delete-member-family-dialog"
      :visible.sync="deleteMemberFamilyDialogVisible"
      :before-close="handleCloseDeleteMemberFamily"
    >
      <div class="dialog-content">
        <div v-if="isShowDeleteMemberFamily">
          <p class="title">削除対象を選択してください</p>
          <div class="mt-20 pl-50 delete-family-member__content pl-30-m-320">
            <el-checkbox-group v-model="deleteMemberFamilies">
              <el-checkbox v-for="member in deleteMemberFamiliesFilter" :key="member.id" :label="member">{{member.name}}</el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
        <div v-if="!isShowDeleteMemberFamily">
          <p class="title">以下を削除します。よろしいですか？</p>
          <ul class="mt-20 pl-50 pl-30-m-320">
            <li v-for="member in deleteMemberFamilies" :key="'confirm_'+member.id" class="mt-10">{{member.name}}</li>
          </ul>
        </div>
      </div>
      <span slot="footer">
        <div v-if="isShowDeleteMemberFamily" class="btn-center-mobile">
          <el-button @click="handleCloseDeleteMemberFamily">やめる</el-button>
          <el-button :disabled="deleteMemberFamilies.length === 0" @click="isShowDeleteMemberFamily = false">削除する</el-button>
        </div>
        <div v-if="!isShowDeleteMemberFamily" class="btn-center-mobile">
          <el-button @click="isShowDeleteMemberFamily = true">やめる</el-button>
          <el-button @click="saveDeleteMemberFamily">削除する</el-button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import Vue from 'vue'
  import moment from 'moment'
  import ChronologyApi from '@/api/chronology'
  import MemberMemberFamilyApi from '@/api/member-family'
  import TitleScreen from '@/components/common/TitleScreen'
  import appUtil from '@/mixins/appUtil'
  import { MY_SELF_RELATIONSHIP_ID } from '../../../../common/constance'
  import DateSelect from '../../../../components/common/DateSelect'
  import Sortable from 'sortablejs'
  import LifeEventSelect from '@/components/client/chronology/LifeEventSelect'
  import RelationshipSelect from '@/components/client/chronology/RelationshipSelect'

  export default {
    name: 'EditChronology',
    props: {
      hideTitle: Boolean
    },
    components: {
      DateSelect,
      TitleScreen,
      LifeEventSelect,
      RelationshipSelect
    },
    mixins: [appUtil],
    data () {
      const validateDate = (rule, value, callback) => {
        if (!moment(value, 'YYYY-MM-DD', true).isValid()) {
          callback(new Error('正しい日付を選択してください'))
        } else {
          callback()
        }
      }

      return {
        memberFamilies: [],
        relationships: [],
        eventMasters: [],
        actionMemberFamily: {},
        deleteMemberFamilies: [],
        actionMemberFamilyDialogVisible: false,
        deleteMemberFamilyDialogVisible: false,
        isShowActionMemberFamilyFamily: true,
        isShowDeleteMemberFamily: true,
        isLoading: true,
        actionMemberFamilyRules: {
          name: [
            { required: true, message: '氏名を入力してください', trigger: 'blur' },
            { min: 1, max: 50, message: '1文字以上50文字以内で入力してください', trigger: 'blur' }
          ],
          relationshipId: [
            { required: true, message: '続柄を選択してください', trigger: 'change' }
          ],
          birthday: [
            { validator: validateDate, trigger: 'blur' }
          ]
        },
        memberFamilyAction: null,
        MEMBER_ACTION: {
          CREATE: 'CREATE',
          UPDATE: 'UPDATE'
        },
        tableSort: Sortable,
        countOpen: 0
      }
    },
    methods: {
      async loadData () {
          this.isLoading = true
          const relationshipRes = await ChronologyApi.getRelationship()
          this.relationships = relationshipRes.data.filter(r => r.id !== MY_SELF_RELATIONSHIP_ID)

          const eventMasterRes = await ChronologyApi.getEventMaster()
          this.eventMasters = eventMasterRes.data

          const res = await MemberMemberFamilyApi.getMemberFamilyAndChronicle()
          this.memberFamilies = res.data
          this.isLoading = false
      },
      createMemberFamily () {
        this.actionMemberFamilyDialogVisible = true
        this.memberFamilyAction = this.MEMBER_ACTION.CREATE
        this.actionMemberFamily = {}
      },
      async saveMemberFamily () {
        const res = await MemberMemberFamilyApi.save(this.actionMemberFamily)
        const newMember = res.data
        if (this.memberFamilyAction === this.MEMBER_ACTION.CREATE) {
          this.memberFamilies.push(newMember)
          this.$msgbox({
              title: '家族を追加しました。',
              showClose: true,
              center: true,
              confirmButtonClass: 'btn-msg-box'
          })
          setTimeout(() => { this.$msgbox.close() }, 2000)
        }

        if (this.memberFamilyAction === this.MEMBER_ACTION.UPDATE) {
          const member = this.memberFamilies.find(e => +e.id === +this.actionMemberFamily.id)
          this.$set(member, 'name', newMember.name)
          this.$set(member, 'birthday', newMember.birthday)
            this.$msgbox({
                title: '家族を更新しました。',
                showClose: true,
                center: true,
                confirmButtonClass: 'btn-msg-box'
            })
            setTimeout(() => { this.$msgbox.close() }, 2000)
            let updateData = await MemberMemberFamilyApi.getMemberFamilyAndChronicle()
            this.memberFamilies = updateData.data
            this.countOpen = 0
        }
        this.handleCloseActionMemberFamilyFamily()
      },
      editMemberFamily (memberId) {
        this.actionMemberFamilyDialogVisible = true
        this.memberFamilyAction = this.MEMBER_ACTION.UPDATE
        const member = this.memberFamilies.find(e => +e.id === +memberId)
        this.actionMemberFamily = {
          id: member.id,
          name: member.name,
          birthday: member.birthday,
          relationshipId: member.relationshipId
        }
      },
      async saveDeleteMemberFamily () {
          if (this.deleteMemberFamilies && this.deleteMemberFamilies.length === 0) {
            return
          }

          const memberIds = this.deleteMemberFamilies.map(m => m.id)
          await MemberMemberFamilyApi.delete(memberIds)

          this.memberFamilies = this.memberFamilies.filter(m => !memberIds.includes(m.id))

          this.handleCloseDeleteMemberFamily()

          this.$msgbox({
              title: '家族を削除しました。',
              showClose: true,
              center: true,
              confirmButtonClass: 'btn-msg-box'
          })
          setTimeout(() => { this.$msgbox.close() }, 2000)
      },
      async saveChronicle () {
          this.isLoading = true

          const saveMyChronicleDTOS = this.memberFamilies.map(m => {
            return {
              'memberFamilyId': m.id,
              'myChronicleRequestDTOList': m.myChronicleResponseDTOS
            }
          })

          const res = await ChronologyApi.createOrUpdateChronicle(saveMyChronicleDTOS)
          const data = res.data
          for (const member of this.memberFamilies) {
            const newMember = data.find(m => +m.id === +member.id)
            if (newMember) {
              member.myChronicleResponseDTOS = newMember.myChronicleResponseDTOS
            }
          }

          this.isLoading = false
          this.$msgbox({
              title: 'イベントを保存しました。',
              showClose: true,
              center: true,
              confirmButtonClass: 'btn-msg-box'
          })
          setTimeout(() => { this.$msgbox.close() }, 2000)
      },
      addChronicle (memberId) {
        const member = this.memberFamilies.find(e => +e.id === +memberId)
        const eventYear = +moment().format('YYYY') - +moment(member.birthday).format('YYYY')
        const eventMasters = this.getEventMastersByRelationshipId(member.relationshipId)
        const event = eventMasters.find(e => e.isDefaultCreate === false && e.itemValue === '自由入力')
        if (member.myChronicleResponseDTOS) {
          member.myChronicleResponseDTOS.push({ eventMasterId: event.id, eventYear })
        } else {
          Vue.set(member, 'myChronicleResponseDTOS', [{ eventMasterId: event.id, eventYear }])
        }
        this.showDetailChronicle(member)
        this.scrollToNewChronicle(memberId, member.myChronicleResponseDTOS.length - 1)
      },
      nextToConfirmActionMemberFamilyFamily () {
        this.$refs['actionMemberFamily'].validate((valid) => {
          if (!valid) {
            return
          }
          this.isShowActionMemberFamilyFamily = false
        })
      },
      handleCloseActionMemberFamilyFamily () {
        if (this.$refs['actionMemberFamily']) {
          this.$refs['actionMemberFamily'].resetFields()
        }
        this.actionMemberFamily = {}
        this.actionMemberFamilyDialogVisible = false
        this.isShowActionMemberFamilyFamily = true
      },
      handleCloseDeleteMemberFamily () {
        this.deleteMemberFamilies = []
        this.deleteMemberFamilyDialogVisible = false
        this.isShowDeleteMemberFamily = true
      },
      relationshipName (relationshipId) {
        let vm = this
        const relationships = vm.relationships
          .find(relationship => +relationship.id === +relationshipId)
        var relationshipName = relationships ? relationships.name : ''
        if (relationshipName === '' && relationshipId === 1) { relationshipName = '本人' }
        return relationshipName
      },
      getEventMastersByRelationshipId (relationshipId) {
          let listEventMaster = this.eventMasters.filter(e => (+e.relationshipId === +relationshipId || e.relationshipId == null))
          let otherEvent = listEventMaster.find(e => e.itemValue === '自由入力')
          if (otherEvent) {
              listEventMaster.push(listEventMaster.splice(listEventMaster.indexOf(otherEvent), 1)[0])
          }
          return listEventMaster
      },
      removeChronicle (memberId, index) {
        const member = this.memberFamilies.find(e => +e.id === +memberId)
        member.myChronicleResponseDTOS.splice(index, 1)
      },
      showDetailChronicle (member) {
          this.countOpen++
          this.tableSort.options.sort = false
        Vue.set(member, 'isShowDetailChronicle', true)
      },
      closeDetailChronicle (member) {
          this.countOpen--
          if (this.countOpen === 0) { this.tableSort.options.sort = true }
        Vue.set(member, 'isShowDetailChronicle', false)
      },
      formatEventYear (chronicle, birthday, year) {
        return moment(birthday).add(year, 'year').year()
      },
      changeEventYear (newValue, chronicle, birthday) {
        Vue.set(chronicle, 'eventYear', newValue - moment(birthday).format('YYYY'))
      },
      changeEventMaster (newValue, chronicle) {
        const eventMaster = this.eventMasters.find(e => +e.id === +newValue)
        const eventName = eventMaster && (eventMaster.itemValue !== '自由入力') ? eventMaster.itemValue : ''
        this.$set(chronicle, 'eventName', eventName)
      },
      isDisableEventName (eventMasterId) {
        const eventMaster = this.eventMasters.find(e => +e.id === +eventMasterId)
        return eventMaster && (eventMaster.itemValue !== '自由入力')
      },
      scrollToNewChronicle (memberId, index) {
        this.$nextTick(() => {
          const chronicleElm = this.$el.querySelector(`#chronicle_${memberId}_${index}`)
          if (chronicleElm) {
            window.scroll(0, chronicleElm.offsetTop)
            chronicleElm.querySelector('div.event-name__input input').focus()
          }
        })
      },
      gotoFamilyTimeline () {
        this.$router.push({ name: 'chronology' })
      },
      async updateMemberSort (newIndex, oldIndex) {
        let changeData = {}
        changeData[this.memberFamilies[oldIndex].id] = this.memberFamilies[newIndex].displayOrder
        if (newIndex > oldIndex) {
          for (let i = oldIndex + 1; i <= newIndex; i++) {
            changeData[this.memberFamilies[i].id] = this.memberFamilies[i - 1].displayOrder
          }
        } else {
          for (let i = newIndex; i < oldIndex; i++) {
            changeData[this.memberFamilies[i].id] = this.memberFamilies[i + 1].displayOrder
          }
        }

        Object.keys(changeData).forEach(memberFamilyId => {
          const memberFamily = this.memberFamilies.find(m => +m.id === +memberFamilyId)
          this.$set(memberFamily, 'displayOrder', changeData[memberFamilyId])
        })

        await MemberMemberFamilyApi.updateSortMember(changeData)
        this.memberFamilies = this.memberFamilies.sort((m1, m2) => m1.displayOrder - m2.displayOrder)
      }
    },
    filters: {
      formatDate: function (value) {
        if (value) {
          return moment(value, 'YYYY-MM-DD').format('YYYY[年]MM[月]DD[日]')
        }
      }
    },
    computed: {
      deleteMemberFamiliesFilter: function () {
        return this.memberFamilies.filter(m => m.relationshipId !== MY_SELF_RELATIONSHIP_ID)
      }
    },
    created () {
      this.loadData()
    },
    mounted () {
      const table = document.querySelector('#table-chronology tbody')
      const self = this
      this.tableSort = Sortable.create(table, {
          handle: '.allow-drag',
        onEnd ({ newIndex, oldIndex }) {
          self.updateMemberSort(newIndex, oldIndex)
        },
        delay: 50
      })
    }
  }
</script>

<style scoped>
  @import "../../../../assets/css/custom.css";
  .create-chronology-main {
    padding-bottom: 30px;
  }
  .text-right {
    text-align: right;
  }
  .mt-20 {
    margin-top: 20px;
  }
  .mt-10 {
    margin-top: 10px;
  }
  .mr-10 {
    margin-right: 10px;
  }
  .pl-50 {
    padding-left: 50px;
  }
  .table {
    width: 100%;
    margin: 1em auto;
    /*border: 2px solid #d6d6d6;*/
    border-radius: 10px;
    border-collapse: separate !important;
    -webkit-box-shadow: 2px 9px 18px -3px rgba(113,85,85,1);
    -moz-box-shadow: 2px 9px 18px -3px rgba(113,85,85,1);
    box-shadow: 2px 9px 18px -3px rgba(113,85,85,1);
  }
  table tr:first-child th:first-child {
    border-top-left-radius: 10px;
  }
  table tr:first-child th:last-child {
    border-top-right-radius: 10px;
  }
  table tr:last-child td:first-child {
    border-bottom-left-radius: 10px;
  }

  table tr:last-child td:last-child {
    border-bottom-right-radius: 10px;
  }
  .table td {
    border: 1px solid #d6d6d6;
    text-align: center;
    padding: 1em;
    /*background: #e6f6fe;*/
    font-size: 14px;
    vertical-align: middle;
  }
  .table .bg-blue td {
    background: #8edbff;
  }
  .table .bg-lightblue td {
    background: #e6f6fe;
  }
  .table th {
    border: 1px solid #d6d6d6;
    text-align: center;
    background-color: #f7f0df;
    padding: 1em;
    font-size: 16px;
    font-weight: bold;
    color: #321007;
  }
  .table .btn-detail {
    background-color: black;
    border-color: black;
    width: 15px;
    height: 15px;
    color: white;
    line-height: 7px;
    padding-left: 1px;
  }
  .pl-3 {
    padding-left: 3px!important;
  }
  .d-flex {
    display: flex;
  }
  .align-items-center {
    align-items: center!important;
  }
  .w-100p {
    width: 100%;
  }
  .w-100 {
    width: 100px;
  }
  .w-200 {
    width: 200px;
  }
  .mw-250 {
    max-width: 250px;
  }
  .dialog-content .title {
    text-align: center;
    font-size: 24px;
  }
  .dialog-content .label {
     width: 22%;
     text-align: right;
     padding-right: 1em;
     line-height: 30px;
  }
  .list-inline-item {
    display: inline-block;
  }
  .delete-family-member__content .el-checkbox-group .el-checkbox {
    display: block;
    margin-top: 10px;
    width: fit-content;
  }
  .event-year {
      max-width: 220px;
  }
</style>
